import fetch from '../../../api/fetch';
import { REDUX_ACTIONS } from '../../../shared/config/constants';
import { parseEpicorError, parseError } from '../../../utils/fetchErrorParser';
import { enqueueSnackbar } from '../snackbar';

export const listEpicorSaleOrders = (params) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.EPICOR_SALE_ORDERS_LIST_LOADING,
  });

  let body = {};
  if (params) {
    const filteredParams = Object.entries({
      top: params.topValue,
      company: 'POT',
      select: params.selectValue,
      expand: params.expandValue,
      filter: params.filterValue,
      orderBy: params.orderByValue,
      skip: params.skipValue,
    }).reduce((acc, [key, value]) => {
      if (typeof value === 'string') {
        value = value.trim();
      }
      if (value !== '' && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    body = {
      type: 'GET',
      url: '/saleOrders',
      params: filteredParams,
    };
  } else {
    body = {
      type: 'GET',
      url: '/saleOrders',
      params: {
        company: 'POT',
      },
    };
  }

  return fetch
    .post('epicorProxy', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SALE_ORDERS_LIST_SUCCESS,
        payload: {
          epicorSaleOrders: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SALE_ORDERS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const createEpicorSaleOrders = (data) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.EPICOR_SALE_ORDERS_POSTING,
  });

  const body = {
    url: '/fieldTicket',
    type: 'POST',
    input: data,
  };
  return fetch
    .post('epicorProxy/epicorProxyPost', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SALE_ORDERS_POST_SUCCESS,
        payload: {
          newOrderNum: data.data[0].SaleOrder.OrderNum,
          salesOrdersCreated: data.data,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseEpicorError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.EPICOR_SALE_ORDERS_POST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
